module.exports = __webpack_public_path__ + "static/media/Gaurav Kumar Singh.f0266cb9.jpeg";